export { default } from './TagsSeo';
